import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageHero from '@/components/PageHero';
import Section from '@/components/Section';
import RecruitCard from './components/RecruitCard';
import JobCard from './components/JobCard';
import { HERO, RECRUIT, JOBS } from './config';
import styles from './index.module.scss';

export default function Join() {
  return (
    <div className={styles.page}>
      <Header />
      <main>
        <PageHero image={HERO.image}>
          <h1 className={styles.heroTitle}>{HERO.title}</h1>
          <p>{HERO.subtitle}</p>
        </PageHero>

        <Section title={RECRUIT.title}>
          <div className={styles.cardList}>
            {RECRUIT.cards.map((item) => (
              <RecruitCard key={item.label} overlay={RECRUIT.overlay} {...item} />
            ))}
          </div>
        </Section>

        <Section title={JOBS.title} background={JOBS.image}>
          <div className={styles.jobList}>
            {JOBS.cards.map((item) => (
              <JobCard key={item.title} {...item} />
            ))}
          </div>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
